import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "centered-content" }
const _hoisted_2 = { class: "ion-text-center" }

import { IonContent, IonPage } from '@ionic/vue';
import OfflineImage from "../components/images/OfflineImage.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'OfflineView',
  setup(__props) {

/*
  imports
*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(OfflineImage, { class: "offline-image" })
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "ion-text-center no-internet" }, "No Internet", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ion-text-center" }, "Please check internet connection.", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})